import { render, staticRenderFns } from "./doctorList.vue?vue&type=template&id=5dd23ca1&scoped=true&"
import script from "./doctorList.vue?vue&type=script&lang=js&"
export * from "./doctorList.vue?vue&type=script&lang=js&"
import style0 from "./doctorList.vue?vue&type=style&index=0&id=5dd23ca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd23ca1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dd23ca1')) {
      api.createRecord('5dd23ca1', component.options)
    } else {
      api.reload('5dd23ca1', component.options)
    }
    module.hot.accept("./doctorList.vue?vue&type=template&id=5dd23ca1&scoped=true&", function () {
      api.rerender('5dd23ca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/doctorList.vue"
export default component.exports